<template>
  <b-card title="Accions">
    <b-overlay :show="loading" variant="white" :opacity="1">
      <b-row>
        <!-- UPDATE DATES -->
        <b-col class="mb-1" cols="12">
          <b-button block variant="primary" @click="$bvModal.show('action-update-booking-dates-modal')">
            Modifica dates
          </b-button>
          <b-modal id="action-update-booking-dates-modal" title="Modifica les dates de la reserva" hide-footer centered>
            <booking-dates-form @booking-rates-updated="$bvModal.hide('action-update-booking-dates-modal')" />
          </b-modal>
        </b-col>

        <!-- UPDATE ACCOMMODATION -->
        <b-col v-if="$can('manage', 'all')" class="mb-1" cols="12">
          <b-button block variant="primary" @click="$bvModal.show('action-update-booking-accommodation-modal')">
            Modifica allotjament
          </b-button>
          <b-modal id="action-update-booking-accommodation-modal" title="Modifica l'allotjament de la reserva"
            hide-footer centered no-close-on-backdrop>
            <booking-accommodation-form @updated="$bvModal.hide('action-update-booking-accommodation-modal')"
              @cancel="$bvModal.hide('action-update-booking-accommodation-modal')" />
          </b-modal>
        </b-col>

        <!-- CLIENT NOTIFICATIONS -->
        <b-col cols="12" class="mb-1" v-if="!isFictitious">
          <b-dropdown text="Notificació client" variant="primary" block>
            <b-dropdown-item v-for="notification in clientNotifications" :key="notification.type"
              @click="$bvModal.show(notification.modalId)">
              {{ notification.label }}
            </b-dropdown-item>
          </b-dropdown>
        </b-col>

        <!-- OWNER NOTIFICATIONS -->
        <b-col cols="12" class="mb-1">
          <b-dropdown text="Notificació propietari" variant="primary" block>
            <b-dropdown-item v-for="notification in ownerNotifications" :key="notification.type"
              @click="$bvModal.show(notification.modalId)">
              {{ notification.label }}
            </b-dropdown-item>
          </b-dropdown>
        </b-col>

        <!-- CLIENT NOTIFICATION MODALS -->
        <b-modal v-for="notification in clientNotifications" :key="notification.modalId" :id="notification.modalId"
          :title="notification.modalTitle" hide-footer scrollable size="lg">
          <client-email-notification-form :notification-type="notification.type"
            @sent="handleNotificationSent(notification)" @send-error="handleNotificationError(notification)"
            @marked-as-sent="handleNotificationMarkedAsSent(notification)"
            @mark-as-sent-error="handleNotificationMarkAsSentError(notification)" />
        </b-modal>

        <!-- OWNER NOTIFICATION MODALS -->
        <b-modal v-for="notification in ownerNotifications" :key="notification.modalId" :id="notification.modalId"
          :title="notification.modalTitle" hide-footer scrollable size="lg">
          <owner-email-notification-form :notification-type="notification.type"
            @sent="handleNotificationSent(notification)" @send-error="handleNotificationError(notification)" />
        </b-modal>
      </b-row>
    </b-overlay>
  </b-card>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BButton,
  BModal,
  BOverlay,
  BDropdown,
  BDropdownItem,
} from "bootstrap-vue";
import BookingDatesForm from "@/views/bookings/booking/components/summary/BookingDatesForm.vue";
import BookingAccommodationForm from "@/views/bookings/booking/components/summary/BookingAccommodationForm.vue";
import ClientEmailNotificationForm from "@/views/bookings/booking/components/notifications/ClientEmailNotificationForm.vue";
import OwnerEmailNotificationForm from "@/views/bookings/booking/components/notifications/OwnerEmailNotificationForm.vue";
import { notifyError, notifySuccess } from "@/utils/methods";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BModal,
    BookingDatesForm,
    BookingAccommodationForm,
    BOverlay,
    BDropdown,
    BDropdownItem,
    ClientEmailNotificationForm,
    OwnerEmailNotificationForm,
  },
  data() {
    return {
      clientNotifications: [
        {
          type: 'prebooking-confirmation',
          modalId: 'action-send-client-prebooking-confirmation-modal',
          label: 'Confirmació pre-reserva',
          modalTitle: 'Envia la confirmació de pre-reserva al client',
          successTitle: 'Confirmació enviada',
          successMessage: 'La confirmació de pre-reserva ha estat enviada correctament al client',
          markedSuccessMessage: 'La confirmació de pre-reserva ha estat marcada com enviada',
          errorMessage: 'Hi ha hagut un error al intentar enviar la confirmació de pre-reserva al client, contacta amb en Pedro',
          markErrorMessage: 'Hi ha hagut un error al intentar marcar la confirmació de pre-reserva com enviada, contacta amb en Pedro'
        },
        {
          type: 'booking-confirmation',
          modalId: 'action-send-client-booking-confirmation-modal',
          label: 'Confirmació reserva',
          modalTitle: 'Envia la confirmació de reserva al client',
          successTitle: 'Confirmació enviada',
          successMessage: 'La confirmació de reserva ha estat enviada correctament al client',
          markedSuccessMessage: 'La confirmació de reserva ha estat marcada com enviada',
          errorMessage: 'Hi ha hagut un error al intentar enviar la confirmació de reserva al client, contacta amb en Pedro',
          markErrorMessage: 'Hi ha hagut un error al intentar marcar la confirmació de reserva com enviada, contacta amb en Pedro'
        },
        {
          type: 'booking-modification',
          modalId: 'action-send-client-booking-modification-modal',
          label: 'Modificació reserva',
          modalTitle: 'Envia la modificació de reserva al client',
          successTitle: 'Modificació enviada',
          successMessage: 'La modificació de reserva ha estat enviada correctament al client',
          markedSuccessMessage: 'La modificació de reserva ha estat marcada com enviada',
          errorMessage: 'Hi ha hagut un error al intentar enviar la modificació de reserva al client, contacta amb en Pedro',
          markErrorMessage: 'Hi ha hagut un error al intentar marcar la modificació de reserva com enviada, contacta amb en Pedro'
        },
        {
          type: 'booking-cancellation',
          modalId: 'action-send-client-booking-cancellation-modal',
          label: 'Cancel·lació reserva',
          modalTitle: 'Envia la cancel·lació de reserva al client',
          successTitle: 'Cancel·lació enviada',
          successMessage: 'La cancel·lació de reserva ha estat enviada correctament al client',
          markedSuccessMessage: 'La cancel·lació de reserva ha estat marcada com enviada',
          errorMessage: 'Hi ha hagut un error al intentar enviar la cancel·lació de reserva al client, contacta amb en Pedro',
          markErrorMessage: 'Hi ha hagut un error al intentar marcar la cancel·lació de reserva com enviada, contacta amb en Pedro'
        },
        {
          type: 'checkin-instructions',
          modalId: 'action-send-client-instrucitons-modal',
          label: 'Instruccions d\'arribada',
          modalTitle: 'Envia les instruccions d\'arribada al client',
          successTitle: 'Instruccions enviades',
          successMessage: 'Les instruccions d\'arribada han estat enviades correctament al client',
          markedSuccessMessage: 'Les instruccions d\'arribada han estat marcades com enviades',
          errorMessage: 'Hi ha hagut un error al intentar enviar les instruccions d\'arribada al client, contacta amb en Pedro',
          markErrorMessage: 'Hi ha hagut un error al intentar marcar les instruccions d\'arribada com enviades, contacta amb en Pedro'
        },
        {
          type: 'manual',
          modalId: 'action-send-client-manual-notification-modal',
          label: 'Notificació manual',
          modalTitle: 'Envia una notificació manual al client',
          successTitle: 'Notificació enviada',
          successMessage: 'La notificació ha estat enviada correctament al client',
          markedSuccessMessage: 'La notificació ha estat marcada com enviada',
          errorMessage: 'Hi ha hagut un error al intentar enviar la notificació al client, contacta amb en Pedro',
          markErrorMessage: 'Hi ha hagut un error al intentar marcar la notificació com enviada, contacta amb en Pedro'
        }
      ],
      ownerNotifications: [
        {
          type: 'booking-confirmation',
          modalId: 'action-send-owner-booking-confirmation-modal',
          label: 'Confirmació reserva',
          modalTitle: 'Envia la confirmació de reserva al propietari',
          successTitle: 'Confirmació enviada',
          successMessage: 'La confirmació de reserva ha estat enviada correctament al propietari',
          errorMessage: 'Hi ha hagut un error al intentar enviar la confirmació de reserva al propietari, contacta amb en Pedro'
        },
        {
          type: 'booking-modification',
          modalId: 'action-send-owner-booking-modification-modal',
          label: 'Modificació reserva',
          modalTitle: 'Envia la modificació de reserva al propietari',
          successTitle: 'Confirmació enviada',
          successMessage: 'La modificació de reserva ha estat enviada correctament al propietari',
          errorMessage: 'Hi ha hagut un error al intentar enviar la modificació de reserva al propietari, contacta amb en Pedro'
        },
        {
          type: 'booking-cancellation',
          modalId: 'action-send-owner-booking-cancellation-modal',
          label: 'Cancel·lació reserva',
          modalTitle: 'Envia la cancel·lació de reserva al propietari',
          successTitle: 'Cancel·lació enviada',
          successMessage: 'La cancel·lació de reserva ha estat enviada correctament al propietari',
          errorMessage: 'Hi ha hagut un error al intentar enviar la cancel·lació de reserva al propietari, contacta amb en Pedro'
        },
        {
          type: 'checkin-information',
          modalId: 'action-send-owner-information-modal',
          label: 'Informació d\'arribada',
          modalTitle: 'Envia la informació d\'arribada al propietari',
          successTitle: 'Instruccions enviades',
          successMessage: 'Les instruccions d\'arribada han estat enviades correctament al propietari',
          errorMessage: 'Hi ha hagut un error al intentar enviar les instruccions d\'arribada al propietari, contacta amb en Pedro'
        }
      ]
    };
  },
  computed: {
    loading() {
      return this.$store.getters["booking/loadingSomething"];
    },
    booking() {
      return this.$store.getters["booking/booking"];
    },
    isFictitious() {
      return this.booking?.fictitious || false;
    },
    client() {
      return this.$store.getters["booking/client"];
    },
    clientHasEmail() {
      if (!this.client) return false;
      return !!this.client.email;
    },
    owner() {
      return this.$store.getters["booking/owner"];
    },
    ownerHasEmail() {
      return !!this.owner?.email;
    },
  },
  methods: {
    handleNotificationSent(notification) {
      this.$bvModal.hide(notification.modalId);
      notifySuccess(notification.successTitle, notification.successMessage);
    },
    handleNotificationError(notification) {
      notifyError("Error", notification.errorMessage);
    },
    handleNotificationMarkedAsSent(notification) {
      this.$bvModal.hide(notification.modalId);
      notifySuccess("Marcat com enviat", notification.markedSuccessMessage);
    },
    handleNotificationMarkAsSentError(notification) {
      notifyError("Error", notification.markErrorMessage);
    }
  },
};
</script>
